module.exports = __webpack_public_path__ + "img/skiing_1413_3.0f27e774.jpg";